import { trackError } from '../utils/trackError';
import { StorageClient } from './storageClient/types';

export const STORAGE_BOUNDARY = 'storageClient';
export const STORAGE_ERROR_MESSAGE =
  'Cannot create tracking storage client when storageClient is not in the configParametersRepository';

export const handleTrackingStorageError = (storageClient: StorageClient) => {
  if (!storageClient) {
    trackError(new Error(STORAGE_ERROR_MESSAGE), STORAGE_BOUNDARY);
    return false;
  }
  return true;
};

export const CONFIG_PARAMETERS_DM_BOUNDARY =
  'configParametersRepository/datamesh';
export const CONFIG_PARAMETERS_DM_MESSAGE =
  'Cannot initialize datamesh when visitID or context are not provided';
export const handleDatameshInitError = (visitID: string, context: string) => {
  if (!visitID || !context) {
    trackError(
      new Error(CONFIG_PARAMETERS_DM_MESSAGE),
      CONFIG_PARAMETERS_DM_BOUNDARY
    );
    return false;
  }
  return true;
};

export const CONFIG_PARAMETERS_GA_BOUNDARY =
  'configParametersRepository/googleAnalytics';
export const CONFIG_PARAMETERS_GA_MESSAGE =
  'ga4GroupId is required to correctly send data to Google Analytics 4';
export const handleGaGroupIdError = (ga4GroupId: string) => {
  if (!ga4GroupId) {
    trackError(
      new Error(CONFIG_PARAMETERS_GA_MESSAGE),
      CONFIG_PARAMETERS_GA_BOUNDARY
    );
  }
};
